<template>
  <div class="flex flex-wrap justify-center items-stretch" v-if="isLoaded">
    <div
      class="flex hover:bg-gray-100 p-2 m-1"
      v-for="renderer in renderers"
      :key="renderer.label"
    >
      <div
        class="flex flex-col justify-start items-center w-24 p-2 m-1 cursor-pointer"
        @click="selectRenderer(renderer)"
      >
        <span class="w-12 h-12 mb-2">
          <img
            :src="'/assets/imgs/software/_renderer/' + renderer.slug + '.png'"
            :alt="renderer.name + ' ' + renderer.version"
          />
        </span>
        <div class="whitespace-no-wrap text-sm" v-text="renderer.name"></div>
        <div
          class="whitespace-no-wrap text-sm text-gray-800"
          v-text="renderer.version"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleAxiosError } from "@/boot/functions";

import useSWRV from "@/store/swrv";
import { computed, watch } from "@vue/composition-api";
export default {
  props: ["releaseId"],
  setup(props) {
    const { data, error, isLoaded } = useSWRV(
      "/api/app/applications/releases/" + props.releaseId + "/renderers"
    );

    watch(error, handleAxiosError);
    return {
      renderers: computed(() => data.value && data.value.data),
      isLoaded,
    };
  },
  methods: {
    selectRenderer(renderer) {
      this.$emit("renderer-selected", renderer);
    },
  },
};
</script>
